import React from 'react';
import { Button, Icon, Input } from "semantic-ui-react";
import { Modal, ModalHeader, ModalBody  } from "reactstrap";
import ImageUploader from "react-images-upload";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromRaw,
  convertFromHTML,
} from "draft-js";
import { createEvent } from "../../api";
import LoadingTop from "../../component/LoadingTop";

const AddEvent = (props) => {
  const [name, setName] = React.useState("");
  const [editorState, setEditorState] = React.useState(EditorState.createEmpty())
  const [modal, setModal] = React.useState(false);
  const [file, setFile] = React.useState(null);
  const [thumbnail, setThumbnail] = React.useState(null);
  const [loadingBtn, setLoadingBtn] = React.useState(false);

  const toggle = () => {
    setModal(!modal)
  };

  const handleSubmit = async () => {
    const html = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    setLoadingBtn(true);
    try {
      await createEvent({name, content: html, file});
      window.history.back();
    } catch (err) {}
    setLoadingBtn(false);
  }

  const onDropImage = (images) => {
    setFile(images[0]);
    setThumbnail(URL.createObjectURL(images[0]));
    toggle();
  };

  return (
    <>
      <LoadingTop />
      <div className="card border-0 rounded-0">
        <div className="container py-4 px-5">
          <div className="row">
            <div className="col-md-8 d-flex align-items-center mb-md-0 mb-3">
              <Input 
                className="w-100"
                placeholder="Nama Event"
                onChange={(e) => setName(e.target.value)}
              >
                <input />
              </Input>
            </div>
          </div>
        </div> 
      </div>
      <div className="container mt-3">
        <div className="row">
          <div className="col-md-12">
            <div className="card container shadow-sm py-3 border-0">
              <div className="row">
                <div className="col-md-8">
                  <div className="form-group">
                    <label>Gambar Utama</label>
                    <div className="p-5 w-100 bg-light cursor-pointer" onClick={() => setModal(true)} style={{backgroundImage: "url("+thumbnail+")", backgroundSize: 'cover', backgroundPosition: 'center'}}>
                      <div className="p-3 text-center">
                        <span>
                          {!thumbnail &&
                            <>
                            <Icon name="image outline" size="large"/> Image
                            </>
                          }
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <Editor
                      toolbarClassName="toolbarClassName"
                      wrapperClassName="demo-wrapper"
                      editorClassName="demo-editor"
                      editorState={editorState}
                      onEditorStateChange={(e) => setEditorState(e)}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group mb-5">
                    <label>Tanggal Event</label>
                    <input type="date" name="" className="form-control" id=""/>
                  </div>
                  <Button color='green' fluid size="lg" className="mb-2" loading={loadingBtn} onClick={handleSubmit}>Simpan</Button>
                  <Button color='light' fluid size="lg" onClick={() => window.history.back()}>Batal</Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Pilih Gambar</ModalHeader>
        <ModalBody>
          <ImageUploader
            {...props}
            withIcon={true}
            withPreview={true}
            singleImage={true}
            onChange={onDropImage}
            imgExtension={[".jpg", ".gif", ".png", ".gif", ".jpeg"]}
            maxFileSize={5242880}
          />
        </ModalBody>
      </Modal>
    </>
  )
}

export default AddEvent
